export default __webpack_public_path__ + "static/media/icon-circleTick.fa99148b.svg";